<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>{{data.message}}</div>
<div mat-dialog-actions>
  <button mat-raised-button color="warn" *ngIf="data.buttonDelete" [mat-dialog-close]="confirm()" >Delete</button>
  <button mat-raised-button color="primary" (click)="onNoClick()" mat-dialog-close>Cancel</button>
</div>
